import {Model} from 'vue-mc'
import {required, string, validation} from 'vue-mc/validation'

export default class EventCategory extends Model {
  defaults() {
    return {
      id: null,
      name: null,
      photos: 0,
      visible: true,
      fixed: false,
      display_text_photo: false
    }
  }

  setPhotos(number) {
    this.photos = number
    this.visible = (number > 0)
  }
}
